import { DbName, DbVersion, StoreName } from "../@core/constants/db_name";
import { dbGetAllData, dbInsertAllData } from "./crudDB";

export async function dbLanguageListAllData(data) {
  await dbInsertAllData(
    DbName.LANGUAGE_LIS_TDB,
    DbVersion.FIRST,
    StoreName.LANGUAGE_LIST,
    data
  );
}

export async function dbGetAllLanguageData() {
  return await dbGetAllData(
    DbName.LANGUAGE_LIS_TDB,
    DbVersion.FIRST,
    StoreName.LANGUAGE_LIST,
    "id"
  );
}
